export const routeConfig = {
  meta: {
    title: '首页',
  }
};
